import styled from 'styled-components'
import { widthResize, widthFull, heightFooter, muted, bgApp } from '../Resources/Theme'

export default styled.footer`
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  margin-left: ${props => props.resize ? widthResize : widthFull};
  transition: width 0.28s ease, margin 0.28s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${heightFooter};
  background: ${bgApp};
  color: ${muted};
  font-size: 0.75rem;
  padding-bottom: 12px;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`
